@if (updatable) {
  <rask-list [data]="verksamhetsHandelserResponse">
    <rask-list-column header="Händelse" field="handelse">
      <ng-template let-row="row">
        <div class="row no-gutters">
          @if (hasUnreadData) {
            <div class="col-1 mt-0">
              <i [ngClass]="row.ny ? 'fas fa-exclamation-circle' : '' " aria-hidden="true"></i>
            </div>
            <div class="col-11 ms-n2">
              <rask-text-expander [text]="row.handelse" [rows]="rows"></rask-text-expander>
            </div>
          }
          @if (!hasUnreadData) {
            <div class="col-12">
              <rask-text-expander [text]="row.handelse" [rows]="rows"></rask-text-expander>
            </div>
          }
        </div>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Tidpunkt" field="tidpunkt" width="90px">
      <ng-template let-value>
        {{value | date:'yyyy-MM-dd HH:mm:ss'}}
      </ng-template>
    </rask-list-column>
    <rask-list-column header="Användare" field="anvandare" width="100px"></rask-list-column>
  </rask-list>
}